import React from "react";
import Grid from "@mui/material/Grid";
import YouTube from "react-youtube";

const Video = ({ video }) => {
  const opciones = {
    width: "90%",
    height: "150",
    playerVars: {
      autoplay: 0,
    },
  };
  return (
    <>
      <Grid item xs={12} sm={4} lg={4}>
        <YouTube
          videoId={
            video.contentDetails
              ? video.contentDetails.videoId
              : video.id.videoId
          }
          //id={video.contentDetails.videoId}
          opts={opciones}
        ></YouTube>
      </Grid>
    </>
  );
};

export default Video;
